import { Flame } from "lucide-react";

/**
 * Compact streak pill for the Dashboard header. Always visible so
 * members see momentum every time they open the app. Not a button —
 * clicking it doesn't navigate anywhere (keeps the header calm), but
 * it does animate its Flame icon on new-milestone days.
 *
 * Design tokens match the app's warm palette. Amber gradient reads as
 * "streak" without needing a border or shadow. When the streak is 0 we
 * show a soft, welcoming variant instead of a fire — nothing to shame
 * a first-time user with.
 */
export const StreakPill = ({ current = 0, isMilestoneDay = false }) => {
  const zero = current === 0;
  return (
    <div
      className={
        zero
          ? "inline-flex items-center gap-1.5 h-9 px-3 rounded-full bg-[#F5EEE0] text-[#8B7A55] text-sm font-medium"
          : "inline-flex items-center gap-1.5 h-9 px-3 rounded-full bg-gradient-to-r from-[#F6C071] to-[#E29B4C] text-white text-sm font-semibold shadow-[0_4px_10px_rgba(226,155,76,0.25)]"
      }
      data-testid="streak-pill"
      data-streak-value={current}
      aria-label={zero ? "No practice streak yet" : `${current}-day practice streak`}
      title={zero ? "Start today — your streak begins with the first practice." : `${current}-day streak`}
    >
      <Flame
        className={`w-4 h-4 ${zero ? "text-[#B08D5A]" : "text-white"} ${
          isMilestoneDay ? "animate-pulse" : ""
        }`}
        aria-hidden
      />
      <span className="tabular-nums">{zero ? "Start today" : `${current} day${current === 1 ? "" : "s"}`}</span>
    </div>
  );
};

export default StreakPill;
